import api from "./api";
import { PasswordGroup, CreatePasswordGroup, UpdatePasswordGroup } from "../types/group.types";

export const groupService = {
  async getAll(): Promise<PasswordGroup[]> {
    const response = await api.get("/password-groups");
    return response.data;
  },

  async getById(id: string): Promise<PasswordGroup> {
    const response = await api.get(`/password-groups/${id}`);
    return response.data;
  },

  async create(data: CreatePasswordGroup): Promise<PasswordGroup> {
    const response = await api.post("/password-groups", data);
    return response.data;
  },

  async update(id: string, data: UpdatePasswordGroup): Promise<PasswordGroup> {
    const response = await api.patch(`/password-groups/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/password-groups/${id}`);
  },
};
